'use es6';

import { Loadable } from 'foundations-components/transitional/utils/Loadable';
const loader = () => import( /* webpackChunkName: "activity-log-dialog" */'./ActivityLogModal');
export default Loadable({
  loader,
  LoadingComponent: () => null
});